import { render, staticRenderFns } from "./DialogUserInfo.vue?vue&type=template&id=6c211a2a&scoped=true&"
import script from "./DialogUserInfo.vue?vue&type=script&lang=js&"
export * from "./DialogUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./DialogUserInfo.vue?vue&type=style&index=0&id=6c211a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c211a2a",
  null
  
)

export default component.exports